module.exports = __webpack_public_path__ + "img/8-IMG_0442.6c71977e.png";